<div class="dds-modal-overlay"></div>

<div
  ddsResize
  [ngClass]="{
    'dds-modal_lg': size === 'lg',
    'dds-modal_inverse': isInverse
  }"
  class="dds-modal"
>
  <div class="dds-modal__header">
    <span class="dds-modal__title">Reset submission status</span>
    <dds-button
      size="sm"
      icon="dds-icon_close"
      kind="silent"
      theme="dark"
      ariaLabel="Close modal close button"
      class="dds-modal__close"
      (clicked)="closeResetSubmissionStatusModal()"
    ></dds-button>
  </div>

  <div class="dds-modal__body">
    <div class="body-section">
      <div class="comment margin-top-xs">
        <div>
          <span class="eclipse-small-header-grey">Select a status</span>
        </div>
        <dds-radio-group
          autosave
          [(ngModel)]="status"
          [name]="status"
          [isUncheckable]="status_radioGroupOptions.isUncheckable ?? false"
          [ariaLabel]="'ResetStatusPopUpRadio'"
          [isRequired]="status_radioGroupOptions.isRequired ?? false"
          [errorState]="status_radioGroupOptions.errorState ?? emptySpace"
        >
          <ng-container *ngFor="let radio of statusRadioValues">
            <dds-radio
              *ngIf="radio.options.label && radio.options.theme"
              [value]="radio.value"
              [customClass]="
                'padding-right-half-rem margin-right-s font-size-14'
              "
              [label]="radio.options.label"
              [theme]="radio.options.theme"
              [ariaLabel]="radio.options.label"
            ></dds-radio>
          </ng-container>
        </dds-radio-group>
      </div>

      <div class="comment margin-top-xs">
        <span class="eclipse-small-header-grey"
          >Reason for resetting status</span
        >
        <dds-select
          [placeholder]="selectOptions.placeholder ?? emptySpace"
          [list]="actionDropdownList"
          [(ngModel)]="selectedReason"
          (valueChanged)="handleDropDownSelected($event)"
          [ariaLabel]="'SelectOptions'"
          [isResponsive]="selectOptions.isResponsive??true"
          [size]="selectOptions.size ?? emptySpace"
        ></dds-select>
      </div>
      <div
        *ngIf="showReasonTextBox"
        class="comment margin-bottom-l margin-top-xs"
      >
        <span class="eclipse-small-header-grey">Reason</span>
        <dds-textarea
          [(ngModel)]="otherReasonDescription"
          [placeholder]="textareaOptions.placeholder ?? emptySpace"
          [maxLength]="textareaOptions.maxLength ?? 0"
          [maxLengthPosition]="textareaOptions.maxLengthPosition ?? emptySpace"
          [minHeight]="textareaOptions.minHeight ?? 0"
          [size]="textareaOptions.size ?? emptySpace"
          [ariaLabel]="'Additional details'"
        >
        </dds-textarea>
      </div>
    </div>
  </div>
  <div class="dds-modal__footer">
    <div class="dds-modal__footer-content dds-modal__footer-content_left">
      <dds-button
        class="dds-modal__footer-item"
        (clicked)="saveSubmissionHistoryResetStatus()"
        [disabled]="!formValid()"
        (keyboardClicked)="saveSubmissionHistoryResetStatus()"
        [ariaLabel]="'Reset Status Button'"
        >Reset status</dds-button
      >
      <dds-button
        class="dds-modal__footer-item"
        kind="secondaryLoud"
        [isInverse]="isInverse"
        (clicked)="closeResetSubmissionStatusModal()"
        (keyboardClicked)="closeResetSubmissionStatusModal()"
        [ariaLabel]="'Cancel'"
        >Cancel</dds-button
      >
    </div>
  </div>
</div>
